import { Button, Form, Row } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react';
import OtpInput from 'react-otp-input';



import styles from './otp.module.scss'
import { useRedux } from 'redux/useRedux';
import OtpLogic from './otp_logic';
import { SmsIcon } from 'assets/svgComponent';
import { onChangeAuth, onChangeTime } from '../redux';
const Otp = () => {
    const { formOtp, finish,resendCode } = OtpLogic()
    const { dispatch, authState } = useRedux()
    const [otp, setOtp] = useState("")
   useEffect(() => {
if(authState.status==="otp"){
   var myInterval = setInterval(() => {
        if (authState?.time > 0) {
            dispatch(onChangeTime())
        }
    }, 1000)
    return () => clearInterval(myInterval);
}
    },[authState.status])
   

    return (
        <>
            <Row align={"middle"}>
                <SmsIcon className={styles.logoIcon} />
                <p className='t1 white100 ms10 '  >تایید شماره همراه</p>
            </Row>
            <p className='t3 white100 mt10 mb40 '  >کد ارسال شده به شماره {authState.phone} را در کادر زیر وارد کنید.</p>
            <Button onClick={()=> authState.fromPage ==="login"? dispatch(onChangeAuth("status", "login")):dispatch(onChangeAuth("status", "signUp"))} className='opacityButton smallButton mb20 ' >تغییر یا اصلاح شماره</Button>
            <p className='t5 white100 mt10  '  >کد تایید</p>
            <div className={styles.input}>
                <OtpInput
                    value={otp}
                    onChange={(val) => {
                        setOtp(val)
                        if (val.length === 5)
                           finish(val,authState.fromPage)
                    }}
                    numInputs={5}
                    inputType={"tel"}
                    shouldAutoFocus

                    inputStyle={styles.otp}
                    renderSeparator={<span style={{ color: "transparent" }} > -- </span>}
                    renderInput={(props) => <input  {...props} />}
                />
            </div>
            <Button className='grayButton smallButton  mt20 ' 
            disabled={authState?.time>0?true:false}
             loading={authState.resendCodeLoading} onClick={()=>resendCode()} >ارسال مجدد کد {authState?.time>0?authState?.time:""}</Button>
        </>
    )
}

export default Otp
